/**
 * WGS84 coordinate-domain bounds -- the absolute maxima a latitude and a longitude may take. A pair outside them is a
 * malformed request, never a place any provider could resolve.
 *
 * WHY A LEAF FOR TWO NUMBERS. The domain was validated at two sites in two tool clusters under two SPELLINGS: named
 * consts, one per axis, in `tools/places/static-map.ts`, and bare literals inlined into a four-clause
 * comparison (`isValidCoordinate`, `components/lib/websocket/parse.ts`). Neither could reach the other -- the cross-tool import
 * ban forecloses every shared home under `tools/` -- so the only spelling that could be shared was no spelling at all,
 * and a reader asking "where is a coordinate range-checked" had to grep for a NUMBER. The `const/` layer is the legal
 * home both sites can import, which is what makes this an SSOT rather than a third copy.
 *
 * DELIBERATELY VALUES, NOT A SHARED PREDICATE. The two validators have different CONTRACTS around the same bounds:
 * the places handler has already rejected non-numeric input through `parseNumberLike` and tests `Math.abs`, while the
 * websocket parser carries its own `Number.isNaN` arms because it reads untrusted socket payloads. Folding them into
 * one predicate would merge two guards whose NaN behaviour differs -- the shape-is-not-the-contract decline class -- so
 * only the decision they genuinely share is homed here. Paired forbid-rule: `QUAL-GEO-COORDINATE-BOUND-LITERAL-001`.
 */

/** Latitude domain: [-90, 90] degrees. Poles inclusive. */
export const LATITUDE_ABS_MAX = 90;

/** Longitude domain: [-180, 180] degrees. Antimeridian inclusive at both spellings. */
export const LONGITUDE_ABS_MAX = 180;
